export const enum DeliverType {
  NONE = '',
  FLAT = 'FLAT',
  DELIVERY_HK = 'DELIVERY_HK',
  DELIVERY_MACAU = 'DELIVERY_MACAU',
  DELIVERY_ONSITE = 'DELIVERY_ONSITE'
}

export interface IOrder {
  eventId?: number;
  sessionId?: number;
  siteId?: number;
  ticketNumber?: number;
  token?: string;
  zoneId?: number;
}

export interface IOrderToken {
  token?: string;
  validUntil?: number;
}

export const defaultValue: Readonly<IOrder> = {};
